import type { TFunction } from "i18next";
import type { PmMicroScenario } from "@arc/contracts";
import type { ChipTone } from "./StatusChip.js";

/** Display helpers shared by the board's screens. */
export function phaseLabel(t: TFunction, ms: Pick<PmMicroScenario, "phase" | "prototypeNumber">): string {
  if (ms.phase === "prototyp") return t("pmBoard.phase.prototyp", { number: ms.prototypeNumber ?? 1 });
  return t(`pmBoard.phase.${ms.phase}`);
}

/** The phase chip's dot: neutral for "no script", attention for the concept that still needs input, primary for a
 *  prototype, success for finalised. */
export function phaseTone(phase: PmMicroScenario["phase"]): ChipTone {
  switch (phase) {
    case "kein_drehbuch":
      return "neutral";
    case "konzept":
      return "attention";
    case "prototyp":
      return "primary";
    case "finalisiert":
      return "success";
  }
}

/** D10: "Ansehen" only with a training URL and in a prototype or the final phase. */
export function trainingStage(t: TFunction, ms: PmMicroScenario): string | null {
  if (!ms.trainingUrl || (ms.phase !== "prototyp" && ms.phase !== "finalisiert")) return null;
  return phaseLabel(t, ms);
}

/** A date and time in the active language ("24.10.2026, 09:40"). */
export function formatDateTime(iso: string, lang: string): string {
  return new Intl.DateTimeFormat(lang, { dateStyle: "medium", timeStyle: "short" }).format(new Date(iso));
}
export function formatDate(iso: string, lang: string): string {
  return new Intl.DateTimeFormat(lang, { dateStyle: "medium" }).format(new Date(iso));
}
